function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12 16.0002H34M34 16.0002H37.3453C37.7319 16.0002 38.0706 16.2589 38.1723 16.6319L43.7047 36.9176C43.8534 37.4628 43.443 38.0002 42.8778 38.0002H28M34 16.0002L28 38.0002M28 38.0002H7.13634C6.56687 38.0002 6.15573 37.4552 6.31218 36.9076L10 24.0002",
  strokeWidth: 4.28571
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9999 16.0002H10.5939C10.2366 16.0002 9.91677 16.2219 9.79131 16.5564L7.43417 22.8421C7.22403 23.4025 7.63827 24.0002 8.23674 24.0002H30.9999",
  strokeWidth: 4.28571
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M27.9999 4.00049C29.9999 6.00049 25.9999 8.00049 27.9999 10.0005",
  strokeWidth: 4.28571,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5774 4.00049C22.5775 6.00049 18.5775 8.00049 20.5774 10.0005",
  strokeWidth: 4.28571,
  strokeLinecap: "round"
});

var SvgIcoTogo2 = function SvgIcoTogo2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    stroke: "black",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoTogo2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico-togo2.26475120.svg";
export { ForwardRef as ReactComponent };